import { render } from "./toxicity.vue?vue&type=template&id=002f90e9"
import script from "./toxicity.vue?vue&type=script&lang=js"
export * from "./toxicity.vue?vue&type=script&lang=js"
script.render = render

export default script